import { useI18n } from '../locales/I18n';
import type { ReactNode } from 'react';
import { BookOpen, Check } from 'lucide-react';
import type { Story } from '../stories';
import { relatedStories } from '../domain';
import { StoryCard } from './StoryCard';
import type { StoryActions } from './StoryCard';
export function StoryCompletion({ story, reactionControls, likeControl, onClose, onReread, ...actions }: StoryActions & {
    story: Story;
    reactionControls: ReactNode;
    likeControl: ReactNode;
    onClose: () => void;
    onReread: () => void;
}) {
    const { t } = useI18n();
    const related = relatedStories(story, actions.journal);
    return <main id="main" className="completion-page">
    <section id="finished-panel" aria-label={t("Finished")} className="story-end compact-completion">
      <span className="end-mark"><Check size={21}/></span>
      <h1 tabIndex={-1}>{t("Curiosity looks good on you.")}</h1>
      <p className="end-intro">{t(story.title)}</p>{reactionControls}
      <div className="completion-actions">{likeControl}<button className="text-link" onClick={onClose}>{t("Back to exploring")}</button><button className="text-link" onClick={onReread}>{t("Read it again ")}<BookOpen size={14}/></button></div>
    </section>
    <section id="related-panel" aria-labelledby="related-heading" className="related-panel">
      <div className="related-heading"><h2 id="related-heading">{t("Related")}</h2><span>{t(related.length)} {t(related.length === 1 ? 'story' : 'stories')}</span></div>
      <p>{t('More true stories related to {category} and this story’s topics.',{category:story.category})}</p>
      {related.length ? <div className="results-list">{related.map(item => <StoryCard key={item.id} item={item} {...actions} compact/>)}</div> : <p className="stats-empty">{t("You've explored this trail for now. Try another category to discover more stories.")}</p>}
    </section>
  </main>;
}
